import {BieCropPlugin} from './crop-plugin';
import {BieArrowPlugin} from './arrow-plugin';
import {BieSquarePlugin} from './square-plugin';
import {BieFlipPlugin} from './flip-plugin';
import {BieTextPlugin} from './text-plugin';
import {BieDrawPlugin} from './draw-plugin';
import {BieRotatePlugin} from './rotate-plugin';

export const defaultPlugins = [
  BieCropPlugin,
  BieFlipPlugin,
  BieTextPlugin,
  BieDrawPlugin,
  BieRotatePlugin,
  BieArrowPlugin,
  BieSquarePlugin,
];
